import React, { useState } from 'react';
import { PanelShell } from '../ui/PanelShell';
import { SectionTitle } from '../ui/SectionTitle';
import { FieldRow } from '../ui/FieldRow';
import { NumberField } from '../ui/NumberField';
import { PillButton } from '../ui/PillButton';
import { SelectField } from '../ui/SelectField';
type DrillHolePanelProps = {
  onClose: () => void;
};
export function DrillHolePanel({
  onClose
}: DrillHolePanelProps) {
  const [mode, setMode] = useState('Automatic');
  return <PanelShell title="Drill Hole" onClose={onClose} footer={<>
          <PillButton disabled data-id="element-340" data-mp="2alefdzviouvt">Delete</PillButton>
          <PillButton variant="muted" disabled data-id="element-341" data-mp="2akmsddfzk5h5">
            Apply Edits
          </PillButton>
        </>} data-id="element-339" data-mp="2ocjkvilkghe2">
      
      <SectionTitle data-id="element-342" data-mp="2el6oqesqj528">Hole Geometry</SectionTitle>
      <FieldRow label="Diameter" info className="min-h-[31px]" data-id="element-343" data-mp="32c2ez7hjls7d">
        <NumberField ariaLabel="Diameter" value={6} unit="mm" className="w-[92px]" data-id="element-344" data-mp="32arcdazu2qhu" />
      </FieldRow>
      <FieldRow label="Depth Mode" className="min-h-[31px]" data-id="element-345" data-mp="3755dlu16fruf">
        <SelectField ariaLabel="Depth mode" value={mode} options={['Automatic', 'Manual']} onChange={setMode} className="w-[92px]" data-id="element-346" data-mp="yqdipiv67rae" />
      </FieldRow>
      <FieldRow label="Depth" info className="min-h-[31px]" data-id="element-347" data-mp="18ff3dmcnuwup">
        <NumberField ariaLabel="Depth" value={10} unit="mm" disabled={mode === 'Automatic'} className="w-[92px]" data-id="element-348" data-mp="18gq41dat7ohl" />
      </FieldRow>
      <FieldRow label="Padding" className="min-h-[31px]" data-id="element-349" data-mp="1hg3fgbihun4y">
        <NumberField ariaLabel="Padding" value={2} unit="mm" className="w-[92px]" data-id="element-350" data-mp="1heiiygcmcu4g" />
      </FieldRow>
    </PanelShell>;
}